import * as $ from "jquery";

export default $;